<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="uRRuR7xdj4uBUA68znWGOK9">
<div class="_idGenObjectLayout-1">
<div id="uYZVahpeHgCGagNSxqovdqD">
<img alt="" class="_idGenObjectAttribute-1" src="image/catmoods1.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// adulting.vue?74a44b38